import { categories } from '@/mocks/chaoyang';

export default function ChannelSection() {
  return (
    <section id="pindao" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="mb-8 flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
        <div>
          <p className="mb-2 text-sm font-medium text-primary-600">覆盖每一个吃瓜角落</p>
          <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">热门吃瓜频道</h2>
        </div>
        <p className="max-w-md text-sm text-foreground-600">
          按栏目快速定位朝阳吃瓜热议焦点，进入频道紧跟朝阳吃瓜热门话题的更新节奏。
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((c) => (
          <a
            key={c.name}
            href="#guanyu"
            className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-5 transition hover:border-secondary-300 hover:bg-secondary-50/50"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-xl text-secondary-800 transition group-hover:bg-secondary-200">
              <i className={c.icon}></i>
            </span>
            <div className="min-w-0 flex-1">
              <h3 className="flex items-center gap-2 text-base font-semibold text-foreground-950 group-hover:text-secondary-800">
                {c.name}
                <i className="ri-arrow-right-line text-xs opacity-0 transition group-hover:opacity-100"></i>
              </h3>
              <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{c.desc}</p>
            </div>
            <span className="whitespace-nowrap rounded-full bg-background-100 px-2.5 py-1 text-[11px] text-foreground-600">
              {c.count}
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}